module.exports = __webpack_public_path__ + "img/8.08d0f925.jpg";